/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportsCogsSummaryService
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.cogs')
.factory('ReportsCogsSummaryService', function() {

  function roundedCost(rawCost) {
    return rawCost === null ? 0 : +(rawCost || 0).toFixed(2);
  }

  /**
   * Take the combined results array and return the results for either a single category, or for all categories combined
   */
  var parseResults = function(allResults, categoryIds) {
    var reportResults = [];
    allResults.forEach(function(item) {
      if (categoryIds.length === 0) {
        reportResults.push({
          startTime: item.startTime,
          salesEx: roundedCost(item.salesExcludeTax),
          salesExcludeTaxLinkedOnly: roundedCost(item.salesExcludeTaxLinkedOnly),
          cost: roundedCost(item.cost || 0),
          link: {report: JSON.stringify({time: moment(item.startTime).format(), type: 'day'})},
          costPerc: item.salesExcludeTaxLinkedOnly == 0 ? 0 : roundedCost(item.cost) / item.salesExcludeTaxLinkedOnly * 100
        });
      } else {
        var resultLine = {
          startTime: item.startTime,
          salesEx: 0,
          salesExcludeTaxLinkedOnly: item.salesExcludeTaxLinkedOnly,
          cost: 0,
          link: {report: JSON.stringify({time: moment(item.startTime).format(), type: 'day'}), category: categoryIds[0]},
          costPerc: 0
        };
        if (item.categories) {
          item.categories.forEach(function(itemCat) {
            if (categoryIds.includes(itemCat.posItemCategoryIdentifier)) {
              resultLine = {
                startTime: item.startTime,
                salesEx: roundedCost(itemCat.salesExcludeTax),
                salesExcludeTaxLinkedOnly: roundedCost(itemCat.salesExcludeTaxLinkedOnly),
                cost: roundedCost(itemCat.cost),
                link: {report: JSON.stringify({time: moment(item.startTime).format(), type: 'day'}), category: itemCat.posItemCategoryIdentifier},
                costPerc: itemCat.salesExcludeTaxLinkedOnly == 0 ? 0 : roundedCost(itemCat.cost) / itemCat.salesExcludeTaxLinkedOnly * 100
              };
            }
          });
        }
        reportResults.push(resultLine);
      }
    });

    return reportResults;
  };

  return {
    parseResults: parseResults
  };
});
